export default __webpack_public_path__ + "static/media/compass.f7e02e82.png";